import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerVersamentoModalComponent } from './worker-versamento-modal';

export const WorkerVersamentoModalModule: string = ng
    .module('worker-versamento-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerVersamentoModalComponent', WorkerVersamentoModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-versamento-modal/worker-versamento-modal.module.ts